import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { flow, observable, set } from "mobx";
import { request } from "../utils/request.js";
import { locationRestStatsGet } from "../wp-api/stats.get.js";
class StatsStore {
    constructor(rootStore){
        this.busy = false;
        this.deletableSpaceFormat = "0 B";
        this.deletableSpace = 0;
        this.newThumbnailsCount = 0;
        this.imagesCount = 0;
        this.totalCount = 0;
        this.sizes = {};
        this.schema = "";
        this.fetch = flow(function*() {
            this.busy = true;
            try {
                const result = yield request({
                    location: locationRestStatsGet
                });
                set(this, result);
            } catch (e) {
                console.log(e);
            } finally{
                this.busy = false;
            }
        });
        this.rootStore = rootStore;
    }
}
_ts_decorate([
    observable
], StatsStore.prototype, "busy", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "deletableSpaceFormat", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "deletableSpace", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "newThumbnailsCount", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "imagesCount", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "totalCount", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], StatsStore.prototype, "sizes", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "schema", void 0);
export { StatsStore };
